import angular from 'angular';

import { ErrorSrcDirective } from './error-src.directive';

const MODULE_NAME = 'core.directives.error-src';

angular.module(MODULE_NAME, []).directive('errorSrc', ErrorSrcDirective);

export default MODULE_NAME;
